<template>
  <li class="header-profile profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        style="width: 30px; height: 30px"
        src="@/assets/images/avtar/user.png"
        alt=""
      />
      <div class="media-body">
        <span>{{ user }}</span>
        <p class="mb-0 font-roboto">
          {{ roleName }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li @click="$router.push('/profile')">
        <vue-feather type="user"></vue-feather><span>Account </span>
      </li>      
      <!-- <li>
        <vue-feather type="mail"></vue-feather><span>Inbox</span>
      </li>
      <li>
        <vue-feather type="file-text"></vue-feather><span>Taskboard</span>
      </li>
      <li>
        <vue-feather type="settings"></vue-feather><span>Settings</span>
      </li> -->
      <li @click="logout">
        <vue-feather type="log-in"></vue-feather><span>Log out</span>
      </li>
    </ul>
  </li>
  <!-- <select v-if="isDir" v-model="evpKpi" class="gm-mobile custom-dropdown m-r-15">
    <option v-for="(option, key) in dataKpi" :key="key" :value="option.value">
      {{ option.label }}
    </option>
  </select>
  <select v-if="isSub" v-model="sub" class="gm-mobile custom-dropdown m-r-15">
    <option v-for="(option, key) in dataSub" :key="key" :value="option.value">
      {{ option.label }}
    </option>
  </select>
  <select v-if="isEvent" v-model="event" class="gm-mobile custom-dropdown m-r-15">
    <option v-for="(option, key) in dataEvent" :key="key" :value="option.value">
      {{ option.label }}
    </option>
  </select>
  <select v-if="isGm" v-model="gm" class="gm-mobile custom-dropdown">
    <option v-for="(option, key) in dataGm" :key="key" :value="option.value">
      {{ option.label }}
    </option>
  </select> -->
  <div></div>
</template>

<script>
// import firebase from 'firebase';
// import UserAuth from '../../auth/js/index';
import AuthService from "@/services/auth/auth";
import StorageConfig from "@/services/config/StorageConfig";
import { decrypt } from "@/utils/helper";

const authService = AuthService.build();
export default {
  name: "Profile",
  data() {
    return {
      user: "",
      roleName: "",
      isDir: false,
      isSub: false,
      isEvent: false,
      isGm: false,
      evpKpi: "kpi",
      sub: "kpi",
      event: "kpi",
      gm: "kpi",
      dataGm: [
        { value: "kpi", label: "GM KPI" },
        { value: "kpi2", label: "UID" },
        { value: "kpi3", label: "UIW" },
      ],
      dataKpi: [
        { value: "kpi", label: "Directorate KPI" },
        { value: "kpi2", label: "DITKEU" },
        { value: "kpi3", label: "DITLHC" },
        { value: "kpi4", label: "DITTRANS" },
        { value: "kpi5", label: "DITRETAIL" },
        { value: "kpi6", label: "DITRENBANG" },
        { value: "kpi7", label: "DITMPRO" },
        { value: "kpi8", label: "DITMKIT" },
        { value: "kpi9", label: "DITDIST" },
      ],
      dataSub: [
        { value: "kpi", label: "Sub Holding KPI" },
        { value: "kpi11", label: "BATAM" },
        { value: "kpi2", label: "EMI" },
        { value: "kpi3", label: "HP" },
        { value: "kpi4", label: "ICON" },
        { value: "kpi5", label: "MCTN" },
        { value: "kpi6", label: "PLN EPI" },
        { value: "kpi7", label: "PLN IP" },
        { value: "kpi8", label: "PNP" },
        { value: "kpi9", label: "PLNE" },
        { value: "kpi10", label: "PLNT" },
      ],
      dataEvent: [
        { value: "kpi", label: "EVP KPI" },
        { value: "kpi11", label: "DITKEU" },
        { value: "kpi2", label: "DIVANG" },
        { value: "kpi3", label: "DIVPBH" },
        { value: "kpi4", label: "DIVAKT" },
        { value: "kpi5", label: "DIVMVA" },
      ],
    };
  },
  created() {
    this.getUrl();
    this.getUser();
  },
  methods: {
    getUser() {
      try {
        const dataUser = StorageConfig.getData();
        if (dataUser) {
          const decryptedData = decrypt(dataUser);
          if (decryptedData) {
            const { name, roleName } = JSON.parse(decryptedData);
            this.user = name;
            this.roleName = roleName;
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    getUrl() {
      const path = window.location.pathname;
      if (path === "/generation") {
        this.isDir = true;
        this.isSub = true;
        this.isEvent = true;
        this.isGm = true;
        this.dataSub = [
          { value: "kpi", label: "Sub Holding KPI" },
          { value: "kpi7", label: "PLN IP" },
          { value: "kpi8", label: "PLN NP" },
          { value: "kpi9", label: "PLN EPI" },
        ];
        this.dataEvent = [
          { value: "kpi", label: "EVP KPI" },
          { value: "kpi11", label: "EVP OKI" },
          { value: "kpi2", label: "EVP RSK" },
        ];
        this.dataGm = [
          { value: "kpi", label: "GM KPI" },
          { value: "kpi2", label: "UIK" },
          { value: "kpi3", label: "UIW" },
        ];
      } else if (path === "/finance") {
        this.isDir = false;
        this.isSub = true;
        this.isEvent = true;
        this.isGm = false;
      } else if (path === "/detail-profit") {
        this.isDir = false;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = false;
      } else if (path === "/detail-cash") {
        this.isDir = false;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = false;
      } else if (path === "/detail-assets") {
        this.isDir = false;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = false;
      } else if (path === "/distribution") {
        this.isDir = true;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = true;
        this.dataKpi = [
          { value: "kpi", label: "Directorate KPI" },
          { value: "kpi9", label: "DITDIST" },
        ];
        this.dataEvent = [
          { value: "kpi", label: "EVP KPI" },
          { value: "kpi11", label: "EVP RSD" },
          { value: "kpi2", label: "EVP ODS" },
        ];
      } else if (path === "/legal-human-capital") {
        this.isDir = true;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = true;
        this.dataGm = [
          { value: "kpi", label: "GM KPI" },
          { value: "kpi2", label: "PUSDIKLAT" },
        ];
      } else if (path === "/data-moonshot") {
        this.isDir = false;
        this.isSub = false;
        this.isEvent = true;
        this.isGm = false;
        this.dataEvent = [
          { value: "kpi", label: "EVP KPI" },
          { value: "kpi11", label: "DIVTCO" },
        ];
      } else {
        this.isDir = true;
        this.isSub = true;
        this.isEvent = false;
        this.isGm = false;
      }
    },
    async logout() {
      // firebase
      //   .auth()
      //   .signOut()
      //   .then(() => {
      //     UserAuth.Logout();
      try {
        await authService.logout();
      } catch (error) {
        console.error("Error logging out:", error);
      } finally {
        StorageConfig.clearSession();
        location.reload();
      }
    },
    // },
  },
};
</script>
<style scoped>
.custom-dropdown {
  width: 20%;
  background-color: #00a3e9; /* Set the background color to gray */
  padding: 8px; /* Add padding for better appearance */
  color: white;
  border: none; /* Remove default border */
  border-radius: 4px; /* Add border radius for rounded corners */
  outline: none; /* Remove focus outline */
  /* Add any additional styles here */
}
@media only screen and (max-device-width: 720px) {
  .header-profile {
    display: none !important;
  }
}
</style>
